(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function () {
  function blockDrag(e) {
    if (e.target.closest('a, button, [role="button"], input, select, textarea')) return;
    e.stopPropagation();
  }
  function fixSlides(root) {
    (root || document).querySelectorAll('slideshow-slides').forEach(function (el) {
      if (el.dataset.noDragFix) return;
      el.dataset.noDragFix = '1';
      el.style.cursor = 'default';
      ['pointerdown', 'mousedown', 'touchstart', 'dragstart'].forEach(function (evt) {
        el.addEventListener(evt, blockDrag, true);
      });
    });
  }
  fixSlides(document);
  document.addEventListener('shopify:section:load', function (e) { fixSlides(e.target); });
  new MutationObserver(function () { fixSlides(document); }).observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
